<!-- Hero Section -->
<div class="w-100">
    <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
    <div class="position-relative w-100 overflow-hidden">
        <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/hMicsN122iNzS6cJHzZ8nG031k5xIfqiVrblEflT.jpg"
            alt="Hero Image" class="img-fluid w-100 d-block" />
        <div
            class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-end align-items-center pb-2 pb-md-5">
            <div class="hero-content text-center mb-2 mb-md-5">
                <button mat-raised-button color="primary" class="cta-button"
                    (click)="formSection.scrollIntoView({behavior: 'smooth'})">Become a Partner</button>
            </div>
        </div>
    </div>
</div>

<!-- Why Partner With Us Section -->
<section class="section benefits-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Grow Faster With <span>Virsa</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">
                We empower partners with high-margin products, ready demand, and full backend support.
            </p>
        </div>

        <div class="benefits-grid">
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>store</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Availability on GeM</h3>
                <p>Products available on GeM</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>trending_up</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>High Market Demand</h3>
                <p>Smart classrooms growing nationwide</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>star</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Premium OEM Products</h3>
                <p>Best-in-class IFPs, Panel Safety Shutters, All-in-One PCs, LMS & Digital K-12 Content</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>attach_money</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Attractive Partner Margins</h3>
                <p>Earn strong profits on every sale</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>support_agent</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Marketing & Sales Support</h3>
                <p>We help you sell more</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>local_shipping</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Fast Delivery & Service</h3>
                <p>PAN India Service Network</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>person</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Dedicated Account Manager</h3>
                <p>Personalized support for your growth</p>
            </div>
            <div class="benefit-item">
                <div class="icon-box">
                    <mat-icon>support</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h3>Prompt After-Sales Support</h3>
                <p>Reliable and responsive post-sales assistance to ensure partner and customer satisfaction</p>
            </div>
        </div>
    </div>
</section>

<!-- Margin Structure Section -->
<section class="section margin-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Earn Strong & Stable <span>Profit Margins</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="margin-container">
            <div class="margin-row">
                <div class="margin-content">
                    <h3>IFP Panels</h3>
                    <p>Good margins with additional earning opportunities through installation, AMC, and service
                        contracts</p>
                </div>
                <div class="margin-divider"></div>
            </div>
            <div class="margin-row">
                <div class="margin-content">
                    <h3>IFP Protection (Shutter)</h3>
                    <p>High-demand safety accessory with strong margins, easy upsell with every IFP installation, and
                        consistent repeat business from institutions</p>
                </div>
                <div class="margin-divider"></div>
            </div>
            <div class="margin-row">
                <div class="margin-content">
                    <h3>All-in-One PCs</h3>
                    <p>Attractive margins supported by high-volume institutional and corporate orders</p>
                </div>
                <div class="margin-divider"></div>
            </div>
            <div class="margin-row">
                <div class="margin-content">
                    <h3>LMS / K–12 Content / Digital E-Library</h3>
                    <p>Recurring revenue opportunities through software licensing, renewals, and content subscriptions
                    </p>
                </div>
                <div class="margin-divider"></div>
            </div>
        </div>
        <p class="note text-center mt-4">(Exact margin percentages will be shared after onboarding.)</p>
    </div>
</section>

<!-- Partner Requirements Section -->
<section class="section requirements-section">
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Partner <span>Requirements</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">To ensure quality service, we expect:</p>
        </div>

        <div class="requirements-grid">
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>GST Certificate & Business Registration</span>
            </div>
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Basic IT or Hardware Sales Experience</span>
            </div>
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Annual Sales</span>
            </div>
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Ability to Offer Basic Product Demo</span>
            </div>
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>Local Market Network (Schools / Coaching / Corporates preferred)</span>
            </div>
            <div class="requirement-item">
                <mat-icon>check_circle_outline</mat-icon>
                <span>
                    <div>Showroom & Demo Availability</div>
                    <p style="font-size: 0.85rem; color: #c4c2c2; margin-top: 4px;">Dedicated space for
                        product display and live demos to customers.</p>
                </span>
            </div>
        </div>
    </div>
</section>

<!-- Become a Partner Form Section -->
<section class="section form-section" #formSection>
    <div class="container">
        <div class="section-header text-center">
            <h2 class="section-title">Become a <span>Partner</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="form-wrapper">
            <form [formGroup]="dealerForm" (ngSubmit)="onSubmit()">
                <div class="form-row">
                    <div class="form-group">
                        <label for="fullName">Full Name *</label>
                        <input type="text" id="fullName" formControlName="fullName" class="form-control"
                            placeholder="Enter your full name">
                        <span class="error"
                            *ngIf="dealerForm.get('fullName')?.invalid && dealerForm.get('fullName')?.touched">Required
                            (min 3 chars)</span>
                    </div>
                    <div class="form-group">
                        <label for="companyName">Company Name *</label>
                        <input type="text" id="companyName" formControlName="companyName" class="form-control"
                            placeholder="Enter company name">
                        <span class="error"
                            *ngIf="dealerForm.get('companyName')?.invalid && dealerForm.get('companyName')?.touched">Required</span>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="cityState">City / State *</label>
                        <input type="text" id="cityState" formControlName="cityState" class="form-control"
                            placeholder="City, State">
                        <span class="error"
                            *ngIf="dealerForm.get('cityState')?.invalid && dealerForm.get('cityState')?.touched">Required</span>
                    </div>
                    <div class="form-group">
                        <label for="phone">Phone Number *</label>
                        <input type="tel" id="phone" formControlName="phone" class="form-control"
                            placeholder="10-digit mobile number">
                        <span class="error"
                            *ngIf="dealerForm.get('phone')?.invalid && dealerForm.get('phone')?.touched">Valid 10-digit
                            number required</span>
                    </div>
                </div>

                <div class="form-group">
                    <label for="email">Email *</label>
                    <input type="email" id="email" formControlName="email" class="form-control"
                        placeholder="your.email@example.com">
                    <span class="error"
                        *ngIf="dealerForm.get('email')?.invalid && dealerForm.get('email')?.touched">Valid email
                        required</span>
                </div>
                <div class="form-group">
                    <label for="gstNumber">GST Number *</label>
                    <input type="text" id="gstNumber" formControlName="gstNumber" class="form-control"
                        placeholder="Enter your GST number">
                    <span class="error"
                        *ngIf="dealerForm.get('gstNumber')?.invalid && dealerForm.get('gstNumber')?.touched">Required</span>
                </div>

                <div class="form-group">
                    <label for="businessExperience">Business Experience *</label>
                    <input type="text" id="businessExperience" formControlName="businessExperience" class="form-control"
                        placeholder="Years of experience, key sectors...">
                    <span class="error"
                        *ngIf="dealerForm.get('businessExperience')?.invalid && dealerForm.get('businessExperience')?.touched">Required</span>
                </div>

                <div class="form-group">
                    <label for="message">Message / Requirement</label>
                    <textarea id="message" formControlName="message" class="form-control" rows="4"
                        placeholder="Any specific requirements..."></textarea>
                </div>

                <button type="submit" class="btn-submit" [disabled]="dealerForm.invalid">Submit Application</button>
            </form>
        </div>
    </div>
</section>